import React, { FC, PropsWithChildren } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { SpringHealthEligiblePayload } from "@neuromotion-inc/mightier-ts-sdk";
import type { MemberSearchParams } from "@routes/gs-admin/members.search";

const TanStackQueryDevtools =
  process.env.NODE_ENV === "production"
    ? (): null => null // Render nothing in production
    : React.lazy(() =>
        // Lazy load in development
        import("@tanstack/react-query-devtools").then((res) => ({
          default: res.ReactQueryDevtools,
          // For Embedded Mode
          // default: res.TanStackRouterDevtoolsPanel
        })),
      );

type QueryKey =
  | ["spring-health", "eligibility", SpringHealthEligiblePayload]
  | ["MEMBER_FIND", MemberSearchParams]
  | ["VERIFY_JWT_AUTH"]
  | ["USER_INFO"];

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // default - queries will be refetched if same query key is mounted again (by same or another component)
      // after 60s
      staleTime: 60 * 1000,
    },
  },
});

declare module "@tanstack/react-query" {
  // eslint-disable-next-line no-unused-vars
  interface Register {
    queryKey: QueryKey;
    // mutationKey: MutationKey;
  }
}

export const TanstackQuerySetup: FC<PropsWithChildren> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <TanStackQueryDevtools />
    </QueryClientProvider>
  );
};
